import React from "react";
import AmCharts from "@amcharts/amcharts3-react";
import { Typography } from "material-ui";
import { chartDrawn } from "./../../../utilities/charts";

const fakeData = {
  Encendidas: 4,
  Apagadas: 2
};

const IgnitionStatusChartTile = props => {
  const { data, lang } = props;
  const ignitionStatus = {
    Encendidas: data.EstatusUnidades.filter(d => d.Ignicion).length,
    Apagadas: data.EstatusUnidades.filter(d => !d.Ignicion).length
  };

  return (
    <div className="dashboard-tile">
      {/* <TileIcon /> */}
      <div className="tile-header">{lang.EstadoDeIgnicion}</div>
      <div className="tile-side-chart-body">
        <IgnitionStatusChart lang={lang} data={ignitionStatus} />
      </div>
      <div className="tile-side-chart-footer">
        <div className="title-reportando-bullet">{lang.Encendidas}</div>
        <div>
          <Typography
            variant="title"
            align="left"
            color="textSecondary"
            classes={{ root: "value" }}
          >
            {ignitionStatus.Encendidas}
          </Typography>
        </div>
        <div className="title-fallando-bullet">{lang.Apagadas} </div>
        <div>
          <Typography
            variant="title"
            align="left"
            color="textSecondary"
            classes={{ root: "value" }}
          >
            {ignitionStatus.Apagadas}
          </Typography>
        </div>
      </div>
    </div>
  );
};

const IgnitionStatusChart = props => {
  const { data, lang } = props;

  const config = {
    type: "pie",
    theme: "light",
    listeners: [
      {
        event: "drawn",
        method: chartDrawn
      }
    ],
    dataProvider: [
      {
        title: lang.Encendidas,
        value: data.Encendidas,
        color: "#00C853"
      },
      {
        title: lang.Apagadas,
        value: data.Apagadas,
        color: "#f86262"
      }
    ],
    titleField: "title",
    colorField: "color",
    valueField: "value",
    labelRadius: 5,
    radius: "42%",
    innerRadius: "60%",
    labelText: "",
    export: {
      enabled: false
    }
  };

  return (
    <AmCharts.React
      style={{
        width: "100%",
        height: "12rem",
        fontSize: "10px"
      }}
      options={config}
    />
  );
};

export default IgnitionStatusChartTile;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/DashboardTiles/IgnitionStatusChartTile.js